import { useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import { userActivity } from "../../../../common/constants";
import Rate from "../../../../components/Rating";
import { IKImage } from "imagekitio-react";
import TaskCertificate from "../TaskCertificate";
import "./index.css";
const gradeImg = {
  1: "https://img.learntube.ai/public-assets/Content_player/Group_5508.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1664968484801",
  2: "https://img.learntube.ai/public-assets/Content_player/Group_5545.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1664968485587",
  3: "https://img.learntube.ai/public-assets/Content_player/Group_5509.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1664968485311",
  4: "https://img.learntube.ai/public-assets/Content_player/Group_5509.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1664968485311",
  5: "https://img.learntube.ai/public-assets/Content_player/Group_5507.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1664968484567",
};
const getGrade = (score) => {
  if (score <= 10) {
    return { score, grade: 1, img: gradeImg[1], text: "Poor" };
  } else if (score <= 20) {
    return { score, grade: 2, img: gradeImg[2], text: "Average" };
  } else if (score <= 30) {
    return { score, grade: 3, img: gradeImg[3], text: "Good" };
  } else if (score <= 40) {
    return { score, grade: 4, img: gradeImg[4], text: "Very Good" };
  } else if (score <= 50) {
    return { score, grade: 5, img: gradeImg[5], text: "Excellent" };
  }
};

export function GradeCard(props) {
  const [showScores, setShowScores] = useState(false);
  const gradeObj = getGrade(props?.score);
  const [showGrade, setShowGrade] = useState(false);
  if (props.type !== "notupgraded") {
    return (
      <>
        <div className="m-4 flex flex-col items-center justify-between rounded-xl p-4 shadow-2xl">
          <h2 className="py-2 text-xl font-semibold text-[#050505]">
            See how much you scored{" "}
          </h2>
          <h2 className="py-2 text-2xl font-bold text-[#C87902]">
            You scored {gradeObj?.score}
          </h2>
          <div>
            <img src={gradeObj?.img} alt="gradeObj image" srcset="" />
          </div>
          <h2 className="my-2 text-center text-lg font-medium text-[#D4A709]">
            {" "}
            {gradeObj?.text}
          </h2>
          <div className=" flex justify-between rounded-xl bg-[#F5F8FF] py-2 px-3">
            {" "}
            <Rate
              rating={gradeObj?.grade}
              color={{
                filled: "#FFD700",
                unfilled: "#808080",
              }}
              count={5}
              size={"sm"}
              isReadOnly={true}
            />
            <div className="ml-2 font-medium text-[#4E4E4E]">
              {gradeObj?.grade} out of 5
            </div>
            <br />
          </div>
          <div className="flex flex-col items-center justify-center  rounded-lg bg-[#F9EDCF] py-2 px-4">
            <h2 className="self-start py-2 text-center text-xl font-bold text-[#5E4301]">
              Feedback
            </h2>
            <p className="my-2  self-start text-sm font-medium text-[#9C771B]">
              {props?.feedback}
            </p>
          </div>
          <div className="border-[ #DEDEDE] mt-4  w-full border-t-2">
            <h2
              className="mt-5 cursor-pointer text-center font-medium text-[#050505] underline"
              onClick={() => setShowScores(!showScores)}
            >
              How do we breakdown scores ?
              {showScores ? (
                <FontAwesomeIcon
                  icon={faChevronDown}
                  className="mx-2 "
                  size="1x"
                />
              ) : (
                <FontAwesomeIcon
                  icon={faChevronUp}
                  className="mx-2"
                  size="1x"
                />
              )}
            </h2>
            {showScores && (
              <div className="mt-4 flex flex-col items-center justify-center ">
                <div className="my-2 flex w-1/3 flex-row items-center justify-between rounded-md bg-[#B1FCEB] pl-5 text-center text-sm font-semibold ">
                  1-10
                  <div className="w-1/2 rounded-md bg-[#1B997D] py-1 text-white">
                    Poor
                  </div>
                </div>
                <div className="my-2 flex w-1/3 flex-row  items-center justify-between rounded-md bg-[#B1FCEB] pl-5 text-center text-sm font-semibold ">
                  11-25
                  <div className="w-1/2 rounded-md bg-[#1B997D] py-1 text-white">
                    Average
                  </div>
                </div>
                <div className="my-2 flex w-1/3 flex-row  items-center justify-between rounded-md bg-[#B1FCEB] pl-5 text-center text-sm font-semibold ">
                  26-40
                  <div className="w-1/2 rounded-md bg-[#1B997D] py-1 text-white">
                    Good
                  </div>
                </div>
                <div className="my-2 flex w-1/3 flex-row  items-center justify-between rounded-md bg-[#B1FCEB] pl-5 text-center text-sm font-semibold ">
                  41+
                  <div className="w-1/2 rounded-md bg-[#1B997D] py-1 text-white">
                    Exellent
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        {props?.type === "submission" &&
          props?.status !== "resubmission" &&
          props?.image_link && (
            <TaskCertificate
              image_link={props?.image_link}
              user_task={props?.user_task}
            />
          )}
        {props?.type === "resubmission" &&
          props?.status === "resubmission" &&
          props?.image_link && (
            <TaskCertificate
              image_link={props?.image_link}
              user_task={props?.user_task}
            />
          )}
      </>
    );
  } else {
    return (
      <>
        <div
          className="flex w-full flex-row justify-between border-b-2 py-2"
          onClick={(e) => setShowGrade(!showGrade)}
        >
          <div>Grade </div>
          <button className="ml-4 cursor-pointer text-center">
            <FontAwesomeIcon
              icon={showGrade ? faMinus : faPlus}
              className={`${showGrade ? "text-[#F1870A]" : ""}`}
            />
          </button>
        </div>
        {showGrade && (
          <div className="m-4 flex flex-col items-center justify-between rounded-xl p-4 shadow-2xl">
            <h2 className="py-2 text-2xl font-bold text-[#C87902]">
              You scored __
            </h2>
            <div>
              <img
                src={
                  "https://img.learntube.ai/public-assets/Content_player/Group_5508.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1664968484801"
                }
                alt="smiley face"
                srcset=""
              />
            </div>
            <div className="mt-6 flex flex-row items-center justify-center rounded-md border-2 border-[#F8D07E] bg-[#FFF5E0] px-2 py-1">
              <img
                urlEndpoint="https://img.learntube.ai/public-assets/"
                src={
                  "https://img.learntube.ai/public-assets/PRICING/img6.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1658936163623"
                }
                transformation={[
                  {
                    height: "160",
                    width: "160",
                  },
                ]}
                className="h-4"
              />
              <small className="ml-1 text-sm font-semibold text-[#E8AB2A]">
                {userActivity?.ASK_TASK_REVIEW?.cost}
              </small>
            </div>
            <div className="gradecard-background mt-4 mb-4 flex flex-row items-center justify-center rounded-md border-2 border-[#F8D07E] bg-[#FFF5E0] px-3 py-1">
              <img
                urlEndpoint="https://img.learntube.ai/public-assets/"
                src={
                  "https://img.learntube.ai/public-assets/PRICING/img28.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1662191682870"
                }
                transformation={[
                  {
                    height: "160",
                    width: "160",
                  },
                ]}
                className="h-"
              />
              <small className="text-md ml-2 font-semibold">
                Premium Feature
              </small>
            </div>
            <div className=" flex justify-between rounded-xl bg-[#F5F8FF] py-2 px-3">
              {" "}
              <Rate
                rating={gradeObj?.grade}
                color={{
                  filled: "#FFD700",
                  unfilled: "#808080",
                }}
                count={5}
                size={"sm"}
                isReadOnly={true}
              />
              <div className="ml-2 font-medium text-[#4E4E4E]">? out of 5</div>
              <br />
            </div>
            <div className=" items-center  justify-center rounded-lg py-2 px-4 text-center text-sm font-semibold">
              Please upgrade to receive personalised feedback from a top
              industry expert, get your project graded & get a project
              completion certificate!
            </div>
            <div className="text-md mt-4 text-center font-bold">
              Upgrade to Unlock Your Project Certificate & Increase Chances of
              Getting Hired By 32%
            </div>
            <img
              src={props?.user_task?.certificate_image_link}
              alt=""
              srcset="certificate image link"
              className="mt-5 mb-5 w-1/2"
            ></img>
          </div>
        )}
      </>
    );
  }
}
